import React from 'react';
import Link from '@base/lib/ThemeLink';
import Iconfont from '@base/lib/Iconfont';
import { useRouter } from 'next/router';
import { navConfig } from 'pro/config/account';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';
import HeaderBarTrigger, { HeaderBarTriggerProps } from '@app/common/PageHeader/HeaderBarTrigger';
import HeaderBarDropdown, { HeaderBarMenuProps } from '@app/common/PageHeader/HeaderBarDropdown';
import { useStore, observer } from 'base/store';
import { useTrans } from 'base/utils/i18n';


const Menu: React.FC<HeaderBarMenuProps> = observer(() => {
    const { userStore, persistStore } = useStore();
    const { isLogin, userName, messageNum } = userStore.state;
    const isDealer = userStore.isDealer();
    const router = useRouter();
    const { t } = useTrans();
    const { referralConfig } = persistStore.state;

    const handleLogout = () => {
        userStore.logout();
        router.reload();
    };

    const conditions = {
        showReferrer: referralConfig.showReferralButton,
        notDealer: !isDealer
    };

    const newNavConfig = navConfig.map((item) => {
        return {
            ...item,
            showPoint: item.key === 'message' && !!messageNum,
        }
    }).filter(item => typeof item.condition !== 'string' || conditions[item.condition])

    return (
        <div className={styles['widget-links']}>
            {isLogin ? (
                <Link href={RouteEnum.ORDERS}>
                    <a className={styles.link}>
                        {userName}
                    </a>
                </Link>
            ) : (
                // TODO：使用Link跳转有问题：Facebook btn登出后再跳转登录页出现不展示问题
                <a href={generatePath(RouteEnum.LOGIN, { redirect: router.asPath })} className={styles.link}>
                    {t('web_account_sign_in_register')}
                </a>
            )}

            {newNavConfig.map(item => {
                return (
                    <Link key={item.url} href={item.url}>
                        <a key={item.url} className={styles.link}>
                            <div className={'flex flex-middle'}>
                                <span>{t(item.name)}</span>
                                {item.showPoint && (
                                    <span className={styles['red-point']}/>
                                )}
                            </div>
                        </a>
                    </Link>
                )
            })}

            {isLogin && (
                <a className={styles.link} onClick={handleLogout}>
                    {t('web_account_logout')}
                </a>
            )}
        </div>
    )
});

const HeaderAccount: React.FC = () => {
    const router = useRouter();
    const { userStore, rootStore } = useStore();
    const { isLogin } = userStore.state;
    const { ua: { isMobile } } = rootStore.state;

    const triggerProps: HeaderBarTriggerProps = {
        content: <Iconfont className="icon-user"/>,
        href: isLogin
            ? RouteEnum.ORDERS
            : `${RouteEnum.LOGIN}?redirect=${encodeURIComponent(decodeURIComponent(router.asPath))}`
    };

    return isMobile ? <HeaderBarTrigger {...triggerProps}/> : (
        <HeaderBarDropdown
            triggerProps={triggerProps}
            menu={<Menu/>}
            placement="bottom"
        />
    )
};

export default observer(HeaderAccount);
